<template>
    <v-row v-if="perfilesToggle.length > 1" class="mt-4 mb-2" dense>
        <v-col cols="12" lg="12" class="d-flex justify-center justify-lg-end align-center">
            <v-btn-toggle :value="perfilActivoIndex" mandatory borderless class="profile-toggle">
                <v-btn v-for="perfil in perfilesToggle" :key="perfil.key" small text
                    :class="perfilActivoActual === perfil.label ? 'active-profile' : 'inactive-profile'"
                    @click="cambiarPerfil(perfil.label)">
                    {{ perfil.display }}
                </v-btn>
            </v-btn-toggle>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "AppProfileToggle",
    props: {
        perfiles: {
            type: Array,
            default: () => [],
        },
        perfilActivo: {
            type: String,
            default: null,
        },
        labelMap: {
            type: Object,
            default: () => ({
                'JEFE_UNIDAD': { label: 'JEFE_UNIDAD', display: 'Jefe inmediato' },
                'RRHH': { label: 'RRHH', display: 'Jefe RRHH' },
                'JURIDICO': { label: 'JURIDICO', display: 'Jefe Juridico' },
                'UFI': { label: 'UFI', display: 'Jefe UFI' },
            }),
        },
        orden: {
            type: Array,
            default: () => ['JEFE_UNIDAD', 'RRHH', 'JURIDICO', 'UFI'],
        },
    },
    emits: ['perfilChange'],
    computed: {
        // Perfiles permitidos (ordenados) para mostrar en el toggle
        perfilesToggle() {
            const disponibles = this.perfiles;
            return this.orden
                .filter(key => disponibles.includes(key))
                .map(key => ({ key, ...this.labelMap[key] }));
        },
        // Determinar el perfil activo (si no hay uno elegido, usa el primero disponible)
        perfilActivoActual() {
            if (this.perfilActivo) return this.perfilActivo;
            return this.perfilesToggle.length ? this.perfilesToggle[0].label : null;
        },
        // Índice para el v-btn-toggle
        perfilActivoIndex() {
            const idx = this.perfilesToggle.findIndex(p => p.label === this.perfilActivoActual);
            return idx === -1 ? 0 : idx;
        }
    },
    methods: {
        cambiarPerfil(perfil) {
            this.$emit('perfilChange', perfil);
        },
    },
};
</script>

<style scoped>
.profile-toggle {
    border-radius: 4px;
    overflow: hidden;
    box-shadow: none;
}

.profile-toggle :deep(.v-btn) {
    border-radius: 0 !important;
    text-transform: none;
    font-size: 12px;
    letter-spacing: 0;
    height: 32px;
    padding: 0 16px;
    border: 1px solid #e0e0e0;
    margin: 0 !important;
}

.profile-toggle :deep(.v-btn:first-child) {
    border-radius: 15px 0 0 15px !important;
    border-right: none;
}

.profile-toggle :deep(.v-btn:last-child) {
    border-radius: 0 15px 15px 0 !important;
    border-left: none;
}

.active-profile {
    background-color: #4a4a4a !important;
    color: white !important;
}

.inactive-profile {
    background-color: #f5f5f5 !important;
    color: #666 !important;
}

.inactive-profile:hover {
    background-color: #e8e8e8 !important;
}
</style>
